import { render, staticRenderFns } from "./DialogMFullPage.vue?vue&type=template&id=b66c7662&scoped=true&"
import script from "./DialogMFullPage.vue?vue&type=script&lang=js&"
export * from "./DialogMFullPage.vue?vue&type=script&lang=js&"
import style0 from "./DialogMFullPage.vue?vue&type=style&index=0&id=b66c7662&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66c7662",
  null
  
)

export default component.exports